if (!customElements.get('register-form')) {
  class RegisterForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.buttonSubmit = this.form.querySelector('button[type="submit"]');
      this.marketingInput = this.form.querySelector('[name="customer[accepts_marketing]"]');

      this.subscribeToNewsletter();

      // Update tags when marketing is changed
      this.marketingInput?.addEventListener('change', () => {
        this.subscribeToNewsletter();
      });

      // On form submit, process the subscription first if Newsletter is checked
      this.form.addEventListener('submit', async (e) => {
        if (this.marketingInput.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          this.companyId = window.klaviyoSettings.companyId;
          this.listId = window.klaviyoSettings.listId;

          await this.processSubscription();
        }
      });
    }

    subscribeToNewsletter() {
      this.contactTagsInput = this.contactTagsInput || this.form.querySelector('[name="contact[tags]"]');

      if (this.marketingInput.checked == true) {
        this.contactTagsInput.value = 'newsletter';
      } else {
        this.contactTagsInput.value = '';
      }
    }

    isLoading(loading) {
      this.buttonSubmit.classList.toggle('loading', loading);
    }

    /**
     * Process the newsletter subscription
     */
    async processSubscription() {
      this.isLoading(true);

      try {
        // First, handle Klaviyo subscription
        await this.handleKlaviyoSubscription();

      } catch (err) {
        console.log('I have an error', err);
      } finally {

        // Submit the Shopify form
        this.form.submit();

        this.isLoading(false);
      }
    }

    async handleKlaviyoSubscription() {
      // Get additional customer data
      const firstNameField = this.form.querySelector('[name="customer[first_name]"]');
      const lastNameField = this.form.querySelector('[name="customer[last_name]"]');
      const emailField = this.form.querySelector('[name="customer[email]"]');

      if (!emailField.value) {
        throw new Error('Email is missing');
      }

      // Create the user data
      const userData = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: emailField.value,
                  first_name: firstNameField?.value || '',
                  last_name: lastNameField?.value || '',
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.listId,
              },
            },
          },
        },
      };

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-01-15',
          'content-type': 'application/vnd.api+json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(userData),
      };

      console.log('Klaviyo subscription:', options);

      try {
        // If successful, create the client subscription
        await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.companyId}`, options).then(
          (res) => {
            if (!res.ok) {
              throw new Error('Failed to create client subscription');
            }
            console.log('Klaviyo subscription successful');
          }
        );
      } catch (error) {
        console.log('Klaviyo subscription error (continuing with Shopify registration):', error);
        // Don't throw error here - let Shopify registration continue even if Klaviyo fails
      }
    }
  }

  window.RegisterForm = RegisterForm;
  customElements.define('register-form', RegisterForm);
}
